import { Component, ElementRef, ViewChild, OnInit } from "@angular/core";
import * as registrationStrings from "../stringFiles/registration.json";
import { NewSchoolRegistrationServices } from "./new-school-registration.service";
import { firstValueFrom } from "rxjs";
import { Router } from "@angular/router";
import * as loginStings from "../stringFiles/newLogin.json";
import { commonFunctionService } from "../utils/commonFunctions";
import parsePhoneNumberFromString from 'libphonenumber-js/max';
import * as countryCurrency from 'iso-country-currency';
import { TranslateService } from "@ngx-translate/core";
import { BrandService } from "../brand/brand.service";

declare var $: any;
declare var jquery: any;
declare var customToastr: any;
@Component({
  selector: "app-new-school-registration",
  templateUrl: "./new-school-registration.component.html",
  styleUrl: "./new-school-registration.component.css",
  providers: [NewSchoolRegistrationServices],
})
export class NewSchoolRegistrationComponent implements OnInit {
  @ViewChild("mobileNumber") mobileNumberInput: ElementRef;
  strings: any;
  classInstitutionError: any;
  institutionNameLength: number = 0;
  mobileNumberLength: number = 0;
  validEmailLength: number = 0;
  validUrlLength: number = 0;
  invalidMobileNumber: any;
  validEmail: any;
  validUrl: any;
  urlError: any;
  projectName: string;
  projectDebounceTimer: any;
  suggestedUrl: any;
  otpPage: boolean;
  formData = {
    instituteName: "",
    mobileNumber: "",
    countryCode: "",
    email: "",
    url: "",
    currencyType: "",
  };
  mobileOtp: string[] = ["", "", "", ""];
  emailOtp: string[] = ["", "", "", ""];
  allInputsFilled: boolean = false;
  resendOtp: boolean = false;
  timer: number = 30;
  attemptOtp: number;
  schoolDomainSuggested: [];
  domainAvailable: any = false;
  defaultUrlValidator: any = true;
  loader: boolean = false;
  verificationLoader = false;
  interval: any;
  schoolDetails: boolean;
  preLoader: boolean = false;
  loginStrings: any
  brand = this.brandService.brand;
  ngOnInit() {
    this.checkSession();
  }

  constructor(
    private schoolRegistrationService: NewSchoolRegistrationServices,
    private router: Router,
    private commonFunction: commonFunctionService, private translate: TranslateService,
    private brandService: BrandService
  ) {
    this.initScript();
    this.strings = registrationStrings;
    this.loginStrings = loginStings
    this.suggestedUrl = false;
    this.otpPage = false;
    this.defaultUrlValidator = true;
    this.formData.countryCode = this.strings.defaultCountryCode;
    this.formData.currencyType = this.strings.defaultCurrencyType;
    this.schoolDetails = false;
  }

  initScript() {
    $(".after").empty();
    $("#device-breakpoints").remove();
    $(".after").append(
      "<script>function customToastr(message,type){toastr.options.hideDuration = 0;toastr.clear();" +
      "toastr.options.closeButton = true;toastr.options.progressBar = false;toastr.options.debug = false;" +
      "toastr.options.positionClass = 'toast-top-right';toastr.options.showDuration = 330;toastr.options.hideDuration = 330;" +
      "toastr.options.timeOut = 5000;toastr.options.extendedTimeOut = 1000;toastr.options.showEasing = 'swing';" +
      "toastr.options.hideEasing = 'swing';toastr.options.showMethod = 'slideDown';toastr.options.hideMethod = 'slideUp';" +
      "toastr[type](message, '');return 0;} </" +
      "script>"
    );
  }


  handleKeyDown(event: KeyboardEvent) {
    this.commonFunction.handleKeyDown(event);
  }

  checkInput() {
    this.allInputsFilled =
      (!this.brand.mobileNumberVerificationWhileRegistration || this.mobileOtp.every((input) => input !== "")) &&
      this.emailOtp.every((input) => input !== "");
  }

  getCurrencyByCountryCode(countryCode: string): string {
    return countryCurrency.getAllInfoByISO(countryCode)?.currency || 'USD';
  }

  resendOtpEnabler() {
    this.interval = setInterval(() => {
      this.timer--;
      if (this.timer === 0) {
        clearInterval(this.interval);
        this.resendOtp = true;
      }
    }, 1000);
  }

  goBack() {
    clearInterval(this.interval);
    this.resendOtp = false;
    this.otpPageOpen();
  }

  resendOtpFunction() {
    this.resendOtp = false;
    if (this.attemptOtp <= 0) return;
    this.timer = 30;
    this.resendOtpEnabler();
    this.schoolRegistration(this.formData, true);
  }

  async submitPage() {
    if (!this.invalidMobileNumber) {
      this.schoolRegistration(this.formData, false);
    } else {
       const pleaseEnterValidMobileNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidMobileNumber'))
      customToastr(pleaseEnterValidMobileNumberTranslation, this.strings.errorCode);
    }
  }

  ngAfterViewInit(): void {
    if ($.fn.intlTelInput) {
      const mobileNumberInput = $('#mobile-number');
      mobileNumberInput.intlTelInput({
        initialCountry: this.brand.defaultCountryIso2Lower || 'in',
        separateDialCode: false,
        utilsScript:
          'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.4/js/utils.js',
      });
      mobileNumberInput.on('countrychange', () => {
        const countryCode = mobileNumberInput.intlTelInput(
          'getSelectedCountryData'
        ).dialCode;
        this.formData.countryCode = countryCode;
        this.formData.mobileNumber = ""
        this.invalidMobileNumber = true;
        // Get the currency using the iso-country-currency package
        const countryData = mobileNumberInput.intlTelInput("getSelectedCountryData");
        const countryCodeForCurrency = countryData.iso2;
        const currency = this.getCurrencyByCountryCode(countryCodeForCurrency);
        this.formData.currencyType = currency;
      });
    }
  }

  // These following method for debouncing
  handleDebounceInstituteName(value): void {
    clearTimeout(this.projectDebounceTimer);
    this.projectDebounceTimer = setTimeout(() => {
      this.institutionNameValidator(value);
    }, 800);
  }

  handleDebounceMobileNumber(value: HTMLInputElement): void {
    clearTimeout(this.projectDebounceTimer);
    this.projectDebounceTimer = setTimeout(() => {
      this.mobileNumberValidator(value);
    }, 800);
  }

  handleDebounceEmail(value): void {
    clearTimeout(this.projectDebounceTimer);
    this.projectDebounceTimer = setTimeout(() => {
      this.emailValidator(value);
    }, 800);
  }
  handleDebounceUrl(value): void {
    clearTimeout(this.projectDebounceTimer);
    this.projectDebounceTimer = setTimeout(() => {
      this.urlValidator(value.value);
    }, 800);
  }

  // This is function for institute name validator
  institutionNameValidator(input) {
    var regex = /^[A-Za-z\s]+$/;
    var inputValue = input.value;
    var isValid = regex.test(inputValue);
    this.institutionNameLength = inputValue.length;
    if (!isValid) {
      this.classInstitutionError = true;
    } else {
      if (inputValue.length >= 2) {
        this.suggestionSchoolDomain(inputValue);
      }
      this.classInstitutionError = false;
    }
  }

  mobileNumberValidator(mobileNumberInput: HTMLInputElement): void {
    const fullNumber = $(mobileNumberInput).intlTelInput('getNumber');
    const phoneNumber = parsePhoneNumberFromString(fullNumber);
    if (!phoneNumber) {
      this.invalidMobileNumber = true;
      return;
    }
    const isValid = phoneNumber.isValid();
    const isPossible = phoneNumber.isPossible();
    this.invalidMobileNumber = !(isValid && isPossible);
  }

  emailValidator(input) {
    const regex =
      /^[\w!#$%&'*+/=?^`{|}~-]+(?:\.[\w!#$%&'*+/=?^`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
    var inputValue = input.value;
    this.validEmailLength = inputValue.length;
    var isValid = regex.test(inputValue);
    if (!isValid) {
      this.validEmail = true;
    } else {
      this.validEmail = false;
    }
  }

  // This is function for institute url validator
  async urlValidator(input) {
    var regex = /^[a-z0-9]+$/;
    var inputValue = input;
    this.validUrlLength = inputValue.length;
    var isValid = regex.test(inputValue);
    if (input.length == 0) {
      this.urlError = this.strings.urlErrorFirst;
      this.validUrl = true;
    } else if (!isValid) {
      this.validUrl = true;
      const urlErrorSecondTranslation = await firstValueFrom(this.translate.get('urlErrorSecond'))
      this.urlError = urlErrorSecondTranslation;
      this.domainAvailable = false;
    } else {
      if (inputValue.length >= 2) {
        this.verifySchoolDomain(inputValue);
      }

      this.validUrl = false;
    }
  }

  tabChangeMobile(val: number) {
    let ele = document.querySelectorAll<HTMLInputElement>(".mobile-input");
    if (ele[val - 1].value !== "") {
      ele[val].focus();
    } else if (ele[val - 1].value === "") {
      ele[val - 2].focus();
    }
  }

  tabChangeEmail(val: number) {
    let ele = document.querySelectorAll<HTMLInputElement>(".email-input");
    if (ele[val - 1].value !== "") {
      ele[val].focus();
    } else if (ele[val - 1].value === "") {
      ele[val - 2].focus();
    }
  }
  otpPageOpen() {
    this.otpPage = !this.otpPage;
  }

  async suggestionSchoolDomain(name) {
    try {
      const domainSuffix = this.brand.domainSuffix || window.location.hostname.split(".").slice(1).join(".");
      const response = await firstValueFrom(
        this.schoolRegistrationService.schoolDomainSuggestion(name, domainSuffix)
      );
      if ((response as any).status) {
        if ((response as any).body) {
          this.schoolDomainSuggested = (response as any).body.suggestionList;
        }
      }
    } catch (error) {
      return;
    }
  }

  async verifySchoolDomain(name) {
    try {
      const response = await firstValueFrom(
        this.schoolRegistrationService.schoolDomainVerification(name)
      );
      if ((response as any).status) {
        this.domainAvailable = true;
      } else {
        this.domainAvailable = false;
        this.defaultUrlValidator = false;
      }
    } catch (error) {
      this.domainAvailable = false;
      this.defaultUrlValidator = false;
    }
  }

  getValueOfUrl(value) {
    this.formData.url = value.split(".")[0];
    this.verifySchoolDomain(value.split(".")[0]);
    this.urlValidator(value.split(".")[0]);
  }

  async schoolRegistration(formData, resend) {
    try {
      this.loader = true;
      const domainSuffix = this.brand.domainSuffix || window.location.hostname.split(".").slice(1).join(".");
      const body = {
        instituteName: formData.instituteName,
        countryCode: formData.countryCode,
        mobileNumber: this.formData.mobileNumber,
        emailId: formData.email,
        lang: "en",
        schoolDomain: formData.url,
        partnerDomain: domainSuffix,
      };
      const response = await firstValueFrom(
        this.schoolRegistrationService.schoolRegistrationApi(body)
      );
      if ((response as any).status) {
        if (!resend) {
          this.otpPageOpen();
          this.resendOtpEnabler();
        }
        this.attemptOtp = (response as any).body
          ? (response as any).body.attemptLeft
          : 0;
        this.timer = 30;
      } else {
        customToastr((response as any).message, this.strings.errorCode);
      }
      this.loader = false;
    } catch (error) {
       const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'))
      customToastr(
        error
          ? error.error
            ? error.error.message
            : errorMessageTranslation
          : errorMessageTranslation,
        this.strings.errorCode
      );
      this.loader = false;
      return;
    }
  }

  // Otp verification api call
  async otpVerification() {
    try {
      this.verificationLoader = true;
      const body = {
        emailId: this.formData.email,
        mobileNumber: this.formData.mobileNumber,
        countryCode: this.formData.countryCode,
        currencyType: this.formData.currencyType,
        lang: "en",
        ...(this.brand.mobileNumberVerificationWhileRegistration ? {
          otpForMobile: this.mobileOtp.length == 4
            ? this.mobileOtp[0] +
            this.mobileOtp[1] +
            this.mobileOtp[2] +
            this.mobileOtp[3]
            : null
        } : {}),
        otpForEmail:
          this.emailOtp.length == 4
            ? this.emailOtp[0] +
            this.emailOtp[1] +
            this.emailOtp[2] +
            this.emailOtp[3]
            : null,
      };
      const response = await firstValueFrom(
        this.schoolRegistrationService.otpVerificationApi(body)
      );
      const hostName = window.location.hostname;
      const urlHost = hostName.split(".")[1];
      const responseDetails = response as any;
      if (responseDetails.status) {
        customToastr(responseDetails.body.message, this.strings.successCode);
        if (
          responseDetails.body.loginInfo &&
          responseDetails.body.loginInfo.token
        ) {
          if (urlHost === this.loginStrings.localhost) {
            const subDomain = responseDetails.body.loginInfo.schoolDomain
            const protocol = window.location.protocol + "//";
            this.commonFunction.setCookieLocal(this.loginStrings.usertoken, responseDetails.body.loginInfo.token, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolVerification, this.loginStrings.step1, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolDomain, responseDetails.body.loginInfo.schoolDomain, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolDomain, subDomain, 7);
            this.commonFunction.disableBackButton()
            customToastr(responseDetails.body.message, this.loginStrings.success);
            window.location.href = protocol + subDomain + "." + this.loginStrings.localSchoolDetailsPath
          }
          else {
            const subDomain = responseDetails.body.loginInfo.schoolDomain
            const protocol = window.location.protocol + "//";
            const domainSuffix = this.brand.domainSuffix || window.location.hostname.split(".").slice(1).join(".");
            this.commonFunction.setCookie(this.loginStrings.usertoken, responseDetails.body.loginInfo.token, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolVerification, this.loginStrings.step1, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolDomain, responseDetails.body.loginInfo.schoolDomain, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolDomain, subDomain, 7);
            this.commonFunction.disableBackButton()
            customToastr(responseDetails.body.message, this.loginStrings.success);
            window.location.href = protocol + subDomain + "." + domainSuffix + this.loginStrings.bluewingsSchoolDetailsPath
          }
        }
      }
      this.verificationLoader = false;
    } catch (error) {
      this.verificationLoader = false;
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'))
      customToastr(
        error
          ? error.error
            ? error.error.message
            : errorMessageTranslation
          : errorMessageTranslation,
        this.strings.errorCode
      );
    }
  }

  openLogin() {
    const protocol = window.location.protocol;
    const hostName = window.location.hostname;
    const urlHost = hostName.split(".")[1];
    if (urlHost === this.strings.localhost) {
      window.location.href = this.strings.localHostLogin;
    } else {
      const domainSuffix = this.brand.domainSuffix || hostName.split(".").slice(1).join(".");
      window.location.href = protocol + "//app." + domainSuffix;
    }
  }
  checkSession() {
    this.preLoader = true;
    const tokenCookie = document.cookie.split(';').find(cookie => cookie.trim().startsWith(this.loginStrings.usertoken + this.loginStrings.equalTo));
    let tokenValue = tokenCookie ? tokenCookie.split('=')[1] : null;
    if (tokenValue) {
      const schoolDomain = document.cookie.split(';').find(cookie => cookie.trim().startsWith(this.loginStrings.schoolDomain + this.loginStrings.equalTo));
      let schoolDomainValue = schoolDomain ? schoolDomain.split('=')[1] : null;
      const isFranchiseValue = document.cookie.split(';').find(cookie => cookie.trim().startsWith(this.loginStrings.isFranchise + this.loginStrings.equalTo));
      let isFranchise = isFranchiseValue ? isFranchiseValue.split('=')[1] : null;
      const protocol = window.location.protocol + "//";
      const hostName = window.location.hostname;
      const urlHost = hostName.split(".")[1];
      const domainSuffix = this.brand.domainSuffix || hostName.split(".").slice(1).join(".");
      let redirectUrl = "";
      const schoolVerification = document.cookie.split(';').find(cookie => cookie.trim().startsWith(this.loginStrings.schoolVerification + this.loginStrings.equalTo));
      let schoolVerificationValue = schoolVerification ? schoolVerification.split('=')[1] : null;
      if (urlHost === this.loginStrings.localhost) {
        this.commonFunction.deleteAllLocalCookies()
      } else {
        if (schoolVerificationValue === this.loginStrings.underVerification) {
          redirectUrl = protocol + schoolDomainValue + "." + domainSuffix + this.loginStrings.bluewingsSchoolUnderVerificationPath;
        } else if (schoolVerificationValue === this.loginStrings.step1) {
          redirectUrl = protocol + schoolDomainValue + "." + domainSuffix + this.loginStrings.bluewingsSchoolDetailsPath;
        }
        else {
          if (isFranchise === "1") {
            redirectUrl = protocol + schoolDomainValue + "." + domainSuffix + this.loginStrings.bluewingsFranchiseDashboardPath;
          } else {
            redirectUrl = protocol + schoolDomainValue + "." + domainSuffix + this.loginStrings.bluewingsDashboardPath;
          }
        }
      }
      setTimeout(() => {
        this.preLoader = false;
      }, 2000);
      window.location.href = redirectUrl;
    } else {
      this.router.navigate(["/login"]);
    }
    this.preLoader = false;
  }
}